import React, { useEffect, useState } from 'react'
import FinanceLayout from '../../../../../../layout/components/FinanceLayout'
import { useParams } from 'react-router-dom'
import ledgerEntryServices from '../ledgerEntryServices';
import LedgerDetails from '../components/LedgerDetails';
import { CircularProgress } from '@mui/material';
import { useAppData } from '../../../../../../context/AppDataContext';

function LedgerDetailsPage() {
    const {ledgerId} = useParams();

    const [loading,setLoadingStatus] = useState(false);

    const {ledgerDD,getDDDataById} = useAppData();
    

    const [entryList,setEntryList] = useState([])
    const getEntryList = () =>{
        setLoadingStatus(true);
        ledgerEntryServices.getByLedgerId(ledgerId).then(res=>{
            setEntryList(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getEntryList();
    },[ledgerId])



    

    return (
        <FinanceLayout>
            {loading ?
                <div className='text-center'><CircularProgress/></div>
                :
                <div className='row'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <h3 className='text-primary'>{getDDDataById(ledgerDD,ledgerId).label}</h3>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <LedgerDetails entries={entryList} />
                    </div>
                </div>
            }
            
            
        </FinanceLayout>
    )
}

export default LedgerDetailsPage